import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Location } from '@angular/common';

import { DatePluginService } from './date-plugin.service';
import { BaseModalPageComponent } from '../../base-modal.component';

import { ModalComponent } from '../../modal/modal.component';
import { ConfirmComponent } from '../../modal/confirm.component';

@Component({
    selector: 'date-edit',
    templateUrl: './date-edit.component.html',
    standalone: false
})
export class DateEditPageComponent extends BaseModalPageComponent implements OnInit {
  public actionPlanId: string;
  public actionPlanItemId: string;
  pluginId: string;
  public plugin: any;
  editForm: UntypedFormGroup;
  public processing = false;
  @ViewChild('menuModal', { static: true }) menuModal: ModalComponent;
  @ViewChild('deleteConfirm', { static: true }) deleteConfirm: ConfirmComponent;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private service: DatePluginService,
    location: Location,
    private cdRef: ChangeDetectorRef
  ) {
    super(location);
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['actionPlanId'];
      if (id == null) this.router.navigate([this.inspectionsRoute]);

      this.actionPlanId = id;

      const actionPlanItemId = params['actionPlanItemId'];
      if (actionPlanItemId == null) this.router.navigate([this.inspectionsRoute, this.actionPlanId]);

      this.actionPlanItemId = actionPlanItemId;

      const pluginId = params['pluginId'];
      if (pluginId == null) this.goToBack();

      this.pluginId = pluginId;
      this.editForm = new UntypedFormGroup({});

      this.initData();
    });
  }

  save(model: any) {
    this.processing = true;
    this.service.updateDate(this.actionPlanId, this.actionPlanItemId, this.pluginId, model.date).subscribe((el) => {
      this.processing = false;
      this.goToBack();
    });
  }

  cancel() {
    this.goToBack();
  }

  ngOnInit() {
    this.initRoute();
  }

  initData() {
    this.service.getPlugin(this.actionPlanId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  initForm() {
    this.editForm = new UntypedFormGroup({
      date: new UntypedFormControl(this.plugin.config.Date, Validators.required)
    });
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        this.openDeleteConfirm();
        break;
      default:
    }
  }

  openDeleteConfirm() {
    this.deleteConfirm.open();
  }

  deletePlugin() {
    this.service.deletePlugin(this.actionPlanId, this.actionPlanItemId, this.pluginId).subscribe((success: boolean) => {
      if (success) {
        this.goToBack();
      }
    });
  }
}
